import React from 'react';
import styles from '../../builder.module.scss';

export const BuilderTextComponent = ({ text, is_title }) => (
  <div className={`textBuilder ${is_title && styles.titleTextComponent}`}>{text}</div>
);
